var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transactions',{attrs:{"transaction-class":_vm.transactionClass,"verbose-name":"Remboursement","verbose-name-plural":"Remboursements","ressource":"refunds","add":false,"colors":_vm.colors,"display-pay":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }